import {Injectable, Inject} from '@angular/core';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class Utility {
    states = [];
    successMessages: any;
    poSubject: any;
    route: any;
    userName: any;
    unitArray: any = [
        'Kg/s',
        'Litre/s',
        'Dozen/s',
        'Half dozen/s',
        'Piece/s',
        'Per person/s',
        'Per month/s',
        'Per plate/s'
    ];
    perPageArray = [
        25,
        50,
        100
    ];
    vendorPoGridRecord: any = {
        pageNumber : 1,
        perPage : 25,
        searchString : '',
    };

    paymentRecord: any = {
        pageNumber : 1,
        perPage : 25,
        searchString : '',
    };

    receivedRecord: any = {
        pageNumber : 1,
        perPage : 25,
        searchString : '',
    };

    itemQuantityRecord: any = {
        pageNumber : 1,
        perPage : 25,
        searchString : '',
    };

    itemUsedRecord: any = {
        pageNumber : 1,
        perPage : 25,
        searchString : '',
    };

    itemVendorRecord: any = {
        pageNumber : 1,
        perPage : 25,
        searchString : '',
    };

    vendorItemRecordAdd: any = {
        pageNumber : 1,
        perPage : 25,
        searchString : '',
    };

    vendorItemRecordEdit: any = {
        pageNumber : 1,
        perPage : 25,
        searchString : '',
    };

    vendorPageRecord: any = {
        pageNumber : 1,
        perPage : 25,
        searchString : '',
    };

   itemPageRecord: any = {
        pageNumber : 1,
        perPage : 25,
        searchString : '',
    };

   expensePageRecord: any = {
        pageNumber : 1,
       perPage : 25,
        searchString : '',
    };

   almirahPageRecord: any = {
        pageNumber : 1,
       perPage : 25,
        searchString : '',
    };

   tagsPageRecord: any = {
        pageNumber : 1,
       perPage : 25,
        searchString : '',
    };

   userPageRecord: any = {
        pageNumber : 1,
       perPage : 25,
        searchString : '',
    };

   termsPageRecord: any = {
        pageNumber : 1,
       perPage : 25,
        searchString : '',
    };

   templatesPageRecord: any = {
        pageNumber : 1,
       perPage : 25,
        searchString : '',
    };

   poPageRecord: any = {
        pageNumber : 1,
       perPage : 25,
       vendorId : '',
       unitId : '',
       statusId : '',
    };

   catItemPageRecord: any = {
        pageNumber : 1,
       perPage : 25,
        tagId : 0,
    };

   catVendorPageRecord: any = {
        pageNumber : 1,
       perPage : 25,
        tagId : 0,
    };

    // pageNumber:any;
    poTemplate: any;
    mailData: any = {
        'purchase_data' : '',
        'total_amount' : '',
        'vendor_data' : '',
        'email' : '',
        'status' : '',
    };
    // tudipLogoBase64: any;
    errorMessages: any;
    configurationCkEditor: any;
    constructor() {
        this.unitArray.sort();
        this.poSubject = 'Test Email';
        this.poTemplate = '<b> Hello, </b> <p> Greetings,</p> <p>This is Test Mail</p>'
        this.states = [
            'Andaman and Nicobar Islands',
            'Andra Pradesh',
            'Arunachal Pradesh',
            'Assam',
            'Bihar',
            'Chandigarh',
            'Chhattisgarh',
            'Dadar and Nagar Haveli',
            'Daman and Diu',
            'Delhi',
            'Goa',
            'Gujarat',
            'Haryana',
            'Himachal Pradesh',
            'Jammu and Kashmir',
            'Jharkhand',
            'Karnataka',
            'Kerala',
            'Lakshadeep',
            'Madya Pradesh',
            'Maharashtra',
            'Manipur',
            'Meghalaya',
            'Mizoram',
            'Nagaland',
            'Orissa',
            'Pondicherry',
            'Punjab',
            'Rajasthan',
            'Sikkim',
            'Tamil Nadu',
            'Telangana',
            'Tripura',
            'Uttaranchal',
            'Uttar Pradesh',
            'West Bengal',
        ];

        this.successMessages = {
            'ADD_VENDOR_SUCCESS': 'Vendor added successfully',
            'EDIT_VENDOR_FINANCE_SUCCESS': 'Financial information updated successfully',
            'EDIT_VENDOR_CONTACT_SUCCESS': 'Contact information updated successfully',
            'DELETE_VENDOR_SUCCESS': 'Vendor deleted successfully',
            'ADD_TAG_SUCCESS': 'Category added successfully',
            'EDIT_TAG_SUCCESS': 'Category edited successfully',
            'ADD_TERMS_SUCCESS': 'Terms and conditions added successfully',
            'DELETE_TAG_SUCCESS': 'Category deleted successfully',
            'ADD_ITEM_SUCCESS': 'Item added successfully',
            'EDIT_ITEM_SUCCESS': 'Item updated successfully',
            'DELETE_ITEM_SUCCESS': 'Item deleted successfully',
            'ADD_VENDOR_ITEM_SUCCESS': "Vendor's item added successfully",
            'EDIT_VENDOR_ITEM_SUCCESS': "Vendor's item updated successfully",
            'DELETE_VENDOR_ITEM_SUCCESS': "Vendor's item deleted successfully",
            'DELETE_ITEM_QUANTITY_SUCCESS': "Item quantity deleted successfully",
            'DELETE_ITEM_USED_SUCCESS': "Item used deleted successfully",
            'DELETE_PURCHASE_ORDER_SUCCESS': "Purchase order deleted successfully",
            'SEND_PURCHASE_ORDER_SUCCESS': "Purchase order sent to vendor Successfully",
            'SEND_MAIL_SUCCESS': "Mail sent to vendor successfully",
            'ADD_PURCHASE_ORDER_SUCCESS': "Purchase order added Successfully",
            'EDIT_PURCHASE_ORDER_SUCCESS': "Purchase order edited successfully",
            'ITEM_QUANTITY_ADD_SUCCESS': 'Items quantity added successfully',
            'USED_QUANTITY_ADD_SUCESS': 'Used quantity added successfully',
            'ALMIRAH_ADD_SUCESS': 'Almirah added successfully',
            'EXPENSE_ADD_SUCESS': 'Expense details added successfully',
            'OFFERING_ADD_SUCESS': 'Offering created successfully.',
            'TEMPLATE_ADD_SUCESS': 'Template added successfully',
            'UNIT_ADD_SUCESS': 'Unit added successfully',
            'UNIT_EDIT_SUCESS': 'Unit edited successfully',
            'USER_ADD_SUCESS': 'User created successfully',
            'ALMIRAH_DELTE_SUCESS': 'Almirah deleted successfully',
            'ALMIRAH_EDIT_SUCESS': 'Almirah edited successfully',
            'EXPENSE_EDIT_SUCESS': 'Expense details edited successfully',
            'CAT_DELETE_SUCESS': 'Category deleted successfully',
            'TERMS_EDITED_SUCCESS': 'Terms and conditions edited successfully',
            'TEMPLATE_EDIT_SUCCESS': 'Template edited successfully',
            'PAYMENT_EDIT_SUCCESS': 'Payment details edited successfully',
            'PAYMENT_ADD_SUCCESS': 'Payment details added successfully',
            'PAYMENT_DELETE_SUCCESS': 'Payment details deleted successfully',
            'RECEIVED_ADD_SUCCESS': 'Received items added successfully',
            'RECEIVED_ITEMS_SUCCESS': 'We have received items',
            'RECEIVED_ITEMS_DELETE_SUCCESS': 'Received item details deleted successfully',
            'EXPENSE_DELETE_SUCCESS' : 'Expense deleted successfully',
            'TEMPLATE_DELETE_SUCCESS' : 'Template deleted successfully',
            'TERMS_DELETE_SUCCESS' : 'Terms and conditions deleted successfully',
            'USER_DELETE_SUCCESS' : 'User deleted successfully',
            'LOGIN_SUCCESSFULL': 'Login successful',
            'PO_COPY_SUCESS': 'Purchase order copied successfully',

        };

        this.errorMessages = {
            'EXCEPTION': 'Something went wrong',
            'ADD_VENDOR_FAIL': 'Vendor added failed',
            'EDIT_VENDOR_FAIL': 'Vendor updated failed',
            'DELETE_VENDOR_FAIL': 'Vendor deleted failed',
            'ADD_TAG_FAIL': 'Category added failed',
            'EDIT_TAG_FAIL': 'Category updated failed',
            'DELETE_TAG_FAIL': 'Category deleted failed',
            'TAG_EXIST': 'Category already exist',
            'TAG_INVALID_ENTRY': 'Please enter category first',
            'ADD_ITEM_FAIL': 'Item added failed',
            'EDIT_ITEM_FAIL': 'Item updated failed',
            'DELETE_ITEM_FAIL': 'Item deleted failed',
            'ITEM_ALREADY_EXIST': 'Item already exist',
            'ADD_VENDOR_ITEM_FAIL': "Vendor's item added failed",
            'EDIT_VENDOR_ITEM_FAIL': "Vendor's item updated failed",
            'DELETE_VENDOR_ITEM_FAIL': "Vendor's item deleted failed",
            'NO_VENDOR_ITEMS': "Vendor's item should not be empty",
            'DELETE_PURCHASE_ORDER_FAIL': 'Purchase order deleted failed',
            'SEND_PURCHASE_ORDER_FAIL': 'Purchase order sending to vendor failed',
            'ADD_PURCHASE_ORDER_FAIL': 'Purchase order added failed',
            'FILL_PURCHASE_ORDER_DETAILS': 'Please fill item details in purchase order first',
            'GET_TAGS_FAILED': 'Failed to get categories',
            'LOCTION_NOT_FOUND': 'Failed to get item locations',
            'FAILED_TO_LOAD_ALL_PO': 'Failed to get all purchase orders',
            'LOGIN_DEACTIVATED': 'User account is de-activated',
            'EMAIL_PASSWORD_INCORRECT': 'Email or password is incorrect',
            'ADD_TERMS': 'Please add terms and conditions to this vendor',
            'ADD_VENDOR_ITEMS': 'Please add vendor-items to this vendor',
            'FAILED_OPEN_PO': 'Failed to open purchase order',
            'FAILED_OPEN_REPORT': 'Failed to open Monthly Expense Report',
            'RESTRICT_ITEM_DELETE': 'Item can not be deleted as used in purchase order',
            'RESTRICT_ITEM_FOR_VENDOR': 'Item can not be deleted as used in item vendors',
            'PO_NOT_SUBMITTED': 'Purchase Order is not submitted',
            'ON_HAND_QUANT_CHECK': 'Please enter quantity less than on hand quantity',
            'ITEM_QUANTITY_ALREADY_EXIST' : "Item's Vendor is already exist",
            'TAG_NOT_CHANGED' : 'Can not change category as It is used',
            'TERMS_NOT_SELECTED' : 'Terms and conditions are not selected',
            'PO_ALREADY_SENT' : 'Purchase order has already sent to vendor',
            'ALMIRAH_ALREADY_EXIST' : 'Almirah already exist',
            'DUPLICATE_VENDOR_ITEM' : 'Vendor\'s item is already exist',
            'DUPLICATE_EMAIL' : 'Email address already exist',
            'INVALID_EMAIL' : 'Please enter valid email address',
            'DUPLICATE_CONTACT' : 'Contact already Exist',
            'EDIT_FAIL' : 'User edited failed',
            'UPDATE_FAIL' : 'User updated successfully',
            'DATA_FAIL' : 'Failed to get data',
            'ALMIRAH_ADD_FAIL' : 'Failed to add almirah',
            'DATE_VALIDATION': 'From date should be less than to date',
            'DATE_VALIDATION_BILL' : 'Bill period from date should be less than bill period To date',
            'EXPESNE_ADD_FAIL' : 'Failed to add expense details',
            'DUPLICATE_TEMPLATE' : 'Template already exist',
            'DUPLICATE_UNIT' : 'Unit already exist',
            'TEMPLATE_FAIL' : 'Template added failed',
            'UNIT_FAIL' : 'Unit added failed',
            'USER_ADD_FAIL' : 'User created failed',
            'ALMIRAH_DELETE_FAIL' : 'Almirah deleted failed',
            'ALMIRAH_DETAILS_FAIL' : 'Failed to get almirah details',
            'UNITS_DETAILS_FAIL' : 'Failed to get units details',
            'ALMIRAH_EDIT_FAIL' : 'Failed to edit almirah',
            'EXPENSE_EDIT_FAIL' : 'Failed to edit expense details',
            'EXPENSE_ADD_FAIL' : 'Failed to add expense details',
            'NAN_CHECK' : 'Please enter valid amounts in item grid',
            'ONE_ITEM_PO' : 'Atleast one item is required in purchase order',
            'PO_EDIT_FAIL' : 'Purchase order edited failed',
            'ITEM_GET_FAIL' : 'Failed to get item details',
            'QUANTITY_PURCHASE_RECEIVED' : 'Quantity purchased should be greater than quantity received',
            'QUANTITY_PURCHASE_RECEIVED_LESS' : 'Quantity received should be less than quantity purchased',
            'DUPLICATE_FILE_AVOID' : 'Duplicate files are not allowed',
            'VENDOR_DELETE_FAIL_PO' : 'Vendor can not be deleted as used in purchase order',
            'VENDOR_DELETE_FAIL_VEN_ITEMS' : 'Vendor can not be deleted as used in vendor items',
            'EXPENSE_DELETE_FAIL' : 'Expense deleted failed',
            'CAT_DELETE_PROHIBIT_FOR_VENDOR' : 'Category can not be deleted as used in vendors',
            'CAT_DELETE_PROHIBIT_FOR_ITEM' : 'Category can not be deleted as used in items',
            'TEMPLATE_DELETE_FAIL' : 'Template deleted failed',
            'UNIT_DELETE_FAIL' : 'Unit deleted failed',
            'USER_DELETE_PROHIBIT' : 'This user can not be deleted',
            'USER_DELETE_FAIL' : 'User deleted failed',
            'RESTRICT_ALMIRAH_DELETE' : 'Can not delete almirah as it is used',
            'DATE_FORMAT_WRONG' : 'Please select date with proper format',
            'DEDUCTION_CHECK' : 'Deduction amount should be less than payment amount',
            'PAYMENT_AMOUNT_CHECK' : 'Payment amount should be less than remaining amount',
        };

    this.configurationCkEditor = {
            // fullPage: true,
            toolbar: [
                {name: 'document', items: ['Source', '-', 'Preview', 'Print', '-', 'Templates']},
                {name: 'links', items: ['Anchor', 'Link', 'Unlink']},
                {name: 'insert', items: ['SpecialChar', 'Iframe', 'HorizontalRule', 'Smiley', '-', 'Image']},
                {name: 'tools', items: ['About', 'Maximize', 'ShowBlocks']}, '/',
                {name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript']},
                {
                    name: 'paragraph',
                    items: ['BulletedList', 'NumberedList', '-', 'JustifyCenter', 'Outdent', 'Indent', 'JustifyLeft', 'JustifyRight', 'JustifyBlock']
                }, '/',
                {name: 'colors', items: ['TextColor', 'BGColor']},
                {name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt']},
                {name: 'clipboard', items: ['Cut', 'Copy', 'Undo', 'Redo']},
                {name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize']}
            ]
        };
    }

    makeFirstLetterCapital(data) {
        return data.replace(/^\w/, function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }

    makeItCapital(data) {
        return data.replace(/\w\S*/g, function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }

    validateDate(testdate) {
        let dateRegex = /^\d{1,2}\/\d{1,2}\/\d{4}$/ ;
        return dateRegex.test(testdate);
    }

    getFirstDayOfCurrentMonth() {
        const date = new Date();
        const preDate = new Date().toISOString().slice(0, 10).split('-');
        const dateString = preDate[2] + '/' + preDate[1] + '/' + preDate[0];
        const firstDateString = new Date(date.getFullYear(), date.getMonth() + 1, 1);
        const firstDate = firstDateString.toString().split(' ')[2] + '/' + preDate[1] + '/' + preDate[0];
        return firstDate;
    }

    getLastDayOfCurrentMonth() {
        const date = new Date();
        const preDate = new Date().toISOString().slice(0, 10).split('-');
        const dateString = preDate[2] + '/' + preDate[1] + '/' + preDate[0];
        const lastDateString = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        const lastDate = lastDateString.toString().split(' ')[2] + '/' + preDate[1] + '/' + preDate[0];
        return lastDate;
    }

}



// WEBPACK FOOTER //
// ./src/app/utilityServices/app.utility.ts